import React from 'react';

import { CheckmarkFilled, ErrorFilled, PlayOutlineFilled, WarningAltFilled, WarningFilled } from '@carbon/icons-react';
import { Tag } from '@varicent/components';
import { ICellRendererParams } from 'ag-grid-community';

import { SymonPipeConfigurationStatus } from 'app/models';

import { formatMessage } from 'utils/messages/utils';

const processingStatusLookUpMap = {
  [SymonPipeConfigurationStatus.NOT_STARTED]: {
    icon: <WarningAltFilled />,
    intent: 'warning',
    text: formatMessage('COLUMNS_NOT_MATCHED')
  },
  [SymonPipeConfigurationStatus.RUNNING]: {
    icon: <PlayOutlineFilled />,
    intent: 'primary',
    text: formatMessage('RUNNING')
  },
  [SymonPipeConfigurationStatus.COMPLETED]: {
    icon: <CheckmarkFilled />,
    intent: 'success',
    text: formatMessage('COMPLETED')
  },
  [SymonPipeConfigurationStatus.FAILED]: {
    icon: <WarningFilled />,
    intent: 'danger',
    text: formatMessage('FAILED')
  },
  [SymonPipeConfigurationStatus.CANCELLED]: {
    icon: <ErrorFilled />,
    intent: 'none',
    text: formatMessage('CANCELLED')
  }
};

const StatusCellRenderer: React.FC<ICellRendererParams> = ({ value }: ICellRendererParams) => {
  const processingStatus = value;
  if (!processingStatusLookUpMap[processingStatus]) return null;
  return (
    <Tag
      data-testid="status-cell-renderer"
      icon={processingStatusLookUpMap[processingStatus].icon}
      intent={processingStatusLookUpMap[processingStatus].intent}
    >
      {processingStatusLookUpMap[processingStatus].text}
    </Tag>
  );
};

export default StatusCellRenderer;
